import { createSelector } from 'reselect';
// import get from 'lodash/get';

export const getConsent = state => state.consent;

export const getConsentData = createSelector(getConsent, consent => consent.data);



// WEBPACK FOOTER //
// ./src/reducers/consent/selectors.js